import { render, staticRenderFns } from "./FileDiskSetting.vue?vue&type=template&id=08b44404&"
import script from "./FileDiskSetting.vue?vue&type=script&lang=js&"
export * from "./FileDiskSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b44404')) {
      api.createRecord('08b44404', component.options)
    } else {
      api.reload('08b44404', component.options)
    }
    module.hot.accept("./FileDiskSetting.vue?vue&type=template&id=08b44404&", function () {
      api.rerender('08b44404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/FileDiskSetting.vue"
export default component.exports